import { IEvent } from "@common/redux/types/event";
import { EntitiesGrid } from "@kursk/components/ui/EntitiesGrid/EntitiesGrid";
import { EventCard } from "../../Home/Events/EventCard/EventCard";
import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { eventsSlice } from "@common/redux/slices/entities.slice";
import { getCardTypeByIdx } from "@kursk/utils/getCardTypeByIdx";
import { useOrientations } from "@common/hooks/useOrientation";
import { useCallback } from "react";

export function EventsGrid({ pushkinPage = false }) {
  const { items, total, offset } = useSelectSlice(eventsSlice);
  const orientation = useOrientations()
  const getCardType = useCallback((index) => {
    return getCardTypeByIdx(index, orientation)
  }, [orientation])

  return (
    <EntitiesGrid
      <IEvent>
      entityType="events"
      items={items}
      total={total}
      offset={offset}
      renderGridCard={
        (item: IEvent, index) => <EventCard key={item._id} event={item} type={getCardType(index)}
          theme="white"/>
      }
      pushkinPage={pushkinPage}
    />
  );
}
